module.exports = __webpack_public_path__ + "static/media/0_2020_02_20.1f136040.jpg";